var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlipIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.436 19.005v-1.569h1.569a1.605 1.605 0 01-1.569 1.569zm0-6.239v-1.533h1.569v1.532zm-3.1-6.2V4.994h1.568v1.569zm3.1 9.341v-1.573h1.569v1.569zm-6.2 4.67V3.425h1.532v17.149zm6.2-15.58a1.605 1.605 0 011.569 1.569h-1.569zM4.994 6.563a1.605 1.605 0 011.569-1.569h3.1v1.569h-3.1v10.873h3.1v1.569h-3.1a1.605 1.605 0 01-1.569-1.569V6.563zm12.442 3.1V8.095h1.569v1.569zm-3.1 9.341v-1.568h1.568v1.569z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 15117",
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}
export default SvgFlipIcon;